import React, { FC } from 'react';
import { Order } from 'models/order';
import { Alert, Box, Button } from '@mui/material';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import { unArchiveOrderTemplate } from 'apollo/templates/order';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';

type UnArchiveOrderDialogProps = {
    onUpdate?: (order: Order) => void;
    onClose: () => void;
    open: boolean;
    orderId: string;
};

const UnArchiveOrderDialog: FC<UnArchiveOrderDialogProps> = ({
    onUpdate,
    onClose,
    open,
    orderId,
}: UnArchiveOrderDialogProps) => {
    const { t: translate } = useTranslation(['orders']);
    const { showBoundary } = useDenthubErrorBoundary();

    const [unArchiveOrder] = useMutation(unArchiveOrderTemplate, {
        onCompleted: ({ unArchiveOrder }) => {
            onClose();
            onUpdate?.(unArchiveOrder);
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const handleUnArchiveOrder = async () => {
        await unArchiveOrder({
            variables: {
                orderId: orderId,
            },
        });
    };

    return (
        <DHDialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={onClose}
            title={translate('orders:UNARCHIVE_THE_ORDER')}
            actions={
                <Button
                    sx={{ minWidth: 250 }}
                    variant="contained"
                    onClick={handleUnArchiveOrder}
                    data-test="unarchive-order-btn"
                >
                    {translate('orders:UNARCHIVE_THE_ORDER')}
                </Button>
            }
        >
            <Box mb={1}>{translate('orders:ARE_YOU_SURE_THAT_YOU_WANT_TO_UNARCHIVE_THE_ORDER')}?</Box>
        </DHDialog>
    );
};
export default UnArchiveOrderDialog;
